import React, { useEffect, useState } from 'react';

export default function InvitationExperience({
  data,
  autoScroll = true,
  initiallyOpen = false
}) {

  const [opened, setOpened] = useState(initiallyOpen);


  useEffect(() => {

    if (autoScroll && opened) {

      setTimeout(() => {

        const el =
          document.getElementById(
            'invitation-content'
          );

        if (el) {

          el.scrollIntoView({
            behavior:'smooth',
            block:'start'
          });

        }

      },700);

    }

  },[opened,autoScroll]);



  const bg =
    data?.palette?.bg ||
    '#f3ede7';


  const text =
    data?.palette?.text ||
    '#2b1e20';



  return (

    <div
      className="
      phone-frame
      phone-frame-lg
      mx-auto
      "
    >

      <div
        className="
        phone-screen
        "
      >


        {!opened && (

          <button

            onClick={() =>
              setOpened(true)
            }

            className="
            absolute
            inset-0
            z-30
            flex
            items-center
            justify-center
            bg-black/40
            "
          >

            <div
              className="
              envelope-cover
              bg-white/90
              rounded-3xl
              px-8
              py-10
              shadow-xl
              text-center
              "
            >

              <div
                className="
                text-5xl
                mb-4
                "
              >
                💌
              </div>

              <div
                className="
                font-serif
                text-xl
                "
              >
                Tocca per aprire
              </div>

            </div>


          </button>

        )}



        <div

          id="invitation-content"

          className={`
          relative
          w-full
          h-full
          overflow-y-auto
          scrollbar-hide
          ${opened ? 'reveal-open':'opacity-0'}
          `}

          style={{
            background:bg,
            color:text
          }}

        >



          <section
            className="
            reveal-block
            min-h-full
            flex
            flex-col
            justify-center
            items-center
            text-center
            px-6
            py-10
            "
          >


            <h1

              className="
              font-serif
              text-4xl
              mb-4
              "

            >

              {
                data?.celebrant ||
                data?.name ||
                'Il tuo evento'
              }


            </h1>



            <p

              className="
              italic-serif
              text-xl
              "

            >

              {
                data?.event ||
                data?.event_name ||
                'Un momento speciale'
              }


            </p>



            <div

              className="
              mt-8
              space-y-3
              text-sm
              "

            >


              {
                data?.date &&
                (

                <div>

                  📅 {new Date(
                    data.date
                  ).toLocaleDateString(
                    'it-IT'
                  )}

                </div>

                )
              }



              {
                data?.time &&
                (

                <div>

                  🕒 Ore {data.time}

                </div>

                )
              }



              {
                data?.location &&
                (

                <div>

                  📍 {data.location}

                </div>

                )
              }


            </div>



          </section>



          {
            data?.message &&
            (

            <section

              className="
              reveal-block
              px-6
              py-10
              text-center
              "

            >

              <p
                className="
                font-serif
                text-xl
                "
              >

                {data.message}

              </p>


            </section>

            )
          }




          {
            data?.program &&
            (

            <section

              className="
              reveal-block
              px-6
              py-10
              text-center
              "

            >

              <h3
                className="
                font-serif
                text-lg
                mb-3
                "
              >
                Programma
              </h3>


              <p
                className="
                text-sm
                whitespace-pre-line
                "
              >
                {data.program}
              </p>


            </section>

            )
          }




          {
            data?.image &&
            (

            <section

              className="
              reveal-block
              px-5
              py-8
              "

            >

              <img

                src={data.image}

                alt="evento"

                className="
                rounded-3xl
                w-full
                object-cover
                "

              />


            </section>

            )
          }



        </div>


      </div>


    </div>

  );

}
